export enum ConsultantContractType {
  Outsource = "Outsource",
  Framework = "Framework",
  Confirmation = "Confirmation",
  Employment = "Employment",
  Intermittent = "Intermittent",
  ConfirmationForEmployees = "ConfirmationForEmployees",
  SelfInvoicing = "SelfInvoicing",
  Outsource_National = "Outsource_National",
  Framework_National = "Framework_National",
  Confirmation_National = "Confirmation_National",
  Employment_National = "Employment_National",
  Intermittent_National = "Intermittent_National",
  ConfirmationForEmployees_National = "ConfirmationForEmployees_National",
  BC_Intermittent = "BC_Intermittent",
  BC_Framework = "BC_Framework",
  BC_Intermittent_Confirmation = "BC_Intermittent_Confirmation",
  BC_Framework_Confirmation = "BC_Framework_Confirmation"
}

export const subcontractorContractTypes = [
  ConsultantContractType.Outsource,
  ConsultantContractType.Outsource_National,
  ConsultantContractType.Framework,
  ConsultantContractType.Framework_National,
  ConsultantContractType.Confirmation,
  ConsultantContractType.Confirmation_National,
  ConsultantContractType.SelfInvoicing,
  ConsultantContractType.BC_Framework,
  ConsultantContractType.BC_Framework_Confirmation
];

export enum ConsultantBookingContractType {
  Outsource = "Outsource",
  Confirmation = "Confirmation"
}

export enum ConsultantContractBonusType {
  GrossSalaryBonus = "GrossSalaryBonus",
  OtherBonus = "OtherBonus"
}

export enum ConsultantContractAccommodationAlt {
  BonlivaPayAccommodation = "BonlivaPayAccommodation",
  BonlivaPayAccommodationAllowance = "BonlivaPayAccommodationAllowance",
  BonlivaPayAccommodationAllowanceAgainstReceipt = "BonlivaPayAccommodationAllowanceAgainstReceipt",
  SupplierPayAccommodation = "SupplierPayAccommodation"
}

export enum ConsultantContractCurrency {
  SEK = "SEK",
  // NOK = "NOK",
  Percentage = "Percentage"
}

export enum ConsultantContractOvertimeOpt {
  NoSpecialOvertime = "NoSpecialOvertime",
  SKLBasedOvertime = "SKLBasedOvertime"
}

export enum ConsultantGetsPaidPer {
  Investigation = "Investigation",
  Hour = "Hour"
}

export enum ConsultantContractPayoutType {
  Weekly = "Weekly",
  Monthly = "Monthly"
}

export enum ConsultantContractPeriod {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  WorkShift = "WorkShift"
}

export enum ConsultantContractPriceType {
  PerHour = "PerHour",
  PerShift = "PerShift",
  PerEmergencyCall = "PerEmergencyCall",
  PerSurgery = "PerSurgery",
  PerInquiry = "PerInquiry",
  PerScreening = "PerScreening",
  PerDay = "PerDay",
  PerWeek = "PerWeek",
  PerMonth = "PerMonth",
  OfRevenue = "OfRevenue"
}

export enum ConsultantContractSalaryType {
  GrossSalary = "GrossSalary",
  NetSalary = "NetSalary"
}

export enum ConsultantContractTravelsAlt {
  BonlivaPayTravel = "BonlivaPayTravel",
  BonlivaPayTravelAllowance = "BonlivaPayTravelAllowance",
  BonlivaPayTravelAllowanceAgainstReceipt = "BonlivaPayTravelAllowanceAgainstReceipt",
  SupplierPayTravel = "SupplierPayTravel",
  ConsultantTaxCompensationAllowance = "ConsultantTaxCompensationAllowance",
  TravelTemplate = "TravelTemplate"
}

export enum ConsultantContractTravelsPeriod {
  Day = "Day",
  Week = "Week",
  Month = "Month",
  Mile = "Mile",
  WorkShift = "WorkShift",
  PerTravel = "PerTravel"
}

export enum ConsultantContractPensionSolution {
  Full = "Full",
  Split = "Split"
}

export enum ConsultantContractSelfInvoicingCheck {
  MustBeSubcontractor = "MustBeSubcontractor",
  MustHaveResponsiblePerson = "MustHaveResponsiblePerson",
  MustHaveEmail = "MustHaveEmail",
  MustHaveSSN = "MustHaveSSN",
  MustHaveBusinessName = "MustHaveBusinessName",
  MustHaveBusinessSSN = "MustHaveBusinessSSN",
  MustHaveBusinessAddress = "MustHaveBusinessAddress",
  MustBeSwedishResident = "MustBeSwedishResident",
  MustHaveFTaxChecked = "MustHaveFTaxChecked",
  MustHaveVATChecked = "MustHaveVATChecked"
}
